import { Lock, DoorOpen, HelpCircle, X, Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { commitmentVisual } from "@/lib/commitmentVisuals";

const ICONS = {
  lock: Lock,
  "door-open": DoorOpen,
  "help-circle": HelpCircle,
  x: X,
  clock: Clock,
} as const;

interface CommitmentChipProps {
  status?: string | null;
  /** Override the label (e.g. to append a count). */
  label?: string;
  size?: "sm" | "md";
  className?: string;
}

/**
 * The one status chip for the whole app. State is always encoded by icon +
 * text as well as colour, so it stays readable without colour perception.
 */
const CommitmentChip = ({ status, label, size = "sm", className }: CommitmentChipProps) => {
  const v = commitmentVisual(status);
  const Icon = ICONS[v.icon];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border-2 font-semibold whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs",
        v.chip,
        className,
      )}
    >
      <Icon className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} aria-hidden="true" />
      {label ?? v.label}
    </span>
  );
};

export default CommitmentChip;
